(function () {
    'use strict';

    // ===== Config =====
    var HPTO_UNIT_REGEX = /^\/86903851\/.*HPTO_2025$/;

    // ===== State =====
    var gptListenerAttached = false;
    var messageListenerAttached = false;
    var pendingSlotEvents = [];
    var initializedSlots = new WeakSet();
    var latestCreativePayload = null; // from postMessage
    // Collapse is allowed only after a real user scroll
    var hasUserScrolled = false;

    function markUserScrolledOnce() {
        hasUserScrolled = true;
        window.removeEventListener('scroll', markUserScrolledOnce, { passive: true });
    }
    window.addEventListener('scroll', markUserScrolledOnce, { passive: true, once: true });

    let isDev =
        location.hostname.includes('lndo') ||
        location.hostname.includes('pantheonsite.io') ||
        location.hostname.includes('kinsta.cloud') ||
        location.hostname === 'localhost';

    function trackAdEvent(eventName, params) {
        if (!window.gtag) return;

        window.gtag('event', eventName, Object.assign({
            creative_type: 'video',
            placement: 'header',
            debug_mode: isDev // sends to DebugView
        }, params || {}));
    }

    // ===== Utils =====
    function domReady() {
        return document.readyState === 'interactive' || document.readyState === 'complete';
    }

    // Session cookie (not sessionStorage): the server needs to read this same
    // value on the next page's first render, to emit the correct expanded/
    // collapsed class immediately instead of starting unclassed (no
    // aspect-ratio, no reserved height) and jumping to its real size only
    // once this script runs -- that jump is a real, measured layout shift
    // that pushes the rest of the page down. See get_hpto_ad_state() in
    // functions.php for the server-side read of this same cookie.
    function setAdStateCookie(state) {
        document.cookie = 'hptoadstate=' + state + '; path=/; SameSite=Lax';
    }

    function getAdStateCookie() {
        var match = document.cookie.match(/(?:^|; )hptoadstate=(expanded|collapsed)(?:;|$)/);
        return match ? match[1] : null;
    }

    function onHptoMessage(ev) {
        var d = ev && ev.data;
        if (!d || d.type !== 'hptoVideo' || d.source !== 'adIframe') return;

        latestCreativePayload = {
            desktopExpanded: d.desktopExpanded || '',
            desktopCollapsed: d.desktopCollapsed || '',
            mobileExpanded: d.mobileExpanded || '',
            mobileCollapsed: d.mobileCollapsed || '',
            videoUrl: d.videoUrl || '',
            videoSide: d.videoSide || ''
        };
        tryProcessHpto();
    }

    function attachMessageListenerOnce() {
        if (messageListenerAttached) return;
        messageListenerAttached = true;
        window.addEventListener('message', onHptoMessage, { passive: true });
    }

    function attachGptListenerOnce() {
        if (gptListenerAttached) return;
        gptListenerAttached = true;

        function wireGptListener() {
            try {
                window.googletag.pubads().addEventListener('slotRenderEnded', function (event) {
                    // Buffer all events; we’ll filter + apply later
                    pendingSlotEvents.push(event);
                    tryProcessHpto();
                });
            } catch (e) {
                // pubads not ready yet, retry
                setTimeout(wireGptListener, 50);
            }
        }

        if (window.googletag && window.googletag.cmd) {
            window.googletag.cmd.push(wireGptListener);
        } else {
            // Wait for googletag to exist
            var t = setInterval(function () {
                if (window.googletag && window.googletag.cmd) {
                    clearInterval(t);
                    window.googletag.cmd.push(wireGptListener);
                }
            }, 50);
        }
    }

    // Try to process buffered slot events when the DOM is ready enough
    function tryProcessHpto() {
        var adContainer = document.querySelector('.adslot-header-sitewrap');
        var hasHptoRoot = document.querySelector('.hpto-container');
        if (!adContainer || !hasHptoRoot) return;
        if (!pendingSlotEvents.length) return;

        var events = pendingSlotEvents.slice();
        pendingSlotEvents.length = 0;

        for (var i = 0; i < events.length; i++) {
            var e = events[i];
            var adUnitPath = e.slot.getAdUnitPath();
            if (!HPTO_UNIT_REGEX.test(adUnitPath)) continue;

            var slotId = e.slot.getSlotElementId();
            var slotEl = document.getElementById(slotId);
            if (!slotEl) continue;

            if (!initializedSlots.has(slotEl)) {
                initHptoForSlot({ slotElement: slotEl, adContainer: adContainer });
            }
        }
    }

    function setRootStateClass(state) {
        var root = document.documentElement;
        root.classList.remove('hpto-ad-expanded', 'hpto-ad-collapsed');
        root.classList.add('hpto-ad-' + state);
    }

    // ===== Per-slot initializer =====
    function initHptoForSlot(opts) {
        var slotElement = opts.slotElement;
        var adContainer = opts.adContainer;
        if (!slotElement || !adContainer) return;
        initializedSlots.add(slotElement);

        // Renamed from 'ad_impression': that name collides with GA4's own
        // automatic per-slot ad_impression event, so this custom impression
        // was unrecoverable in reports. See HPTO Impressions ticket
        // (Brittany/Kevin, Sep 2026) -- approved by Kevin.
        trackAdEvent('hpto_impression', {
            slot_id: slotElement.id
        });

        slotElement.classList.add('generated-ad-class');

        var videoPlayerContainer = document.getElementById('ad-video-container');
        var adBgDesktop = document.getElementById('ad-background-container-desktop');
        var adBgMobile = document.getElementById('ad-background-container-mobile');

        if (!videoPlayerContainer || !adBgDesktop || !adBgMobile) {
            console.warn('[HPTO] Missing required containers; aborting this slot init.');
            return;
        }

        // --- State ---
        var currentAdState = getAdStateCookie() || 'expanded';
        adContainer.classList.add(currentAdState);
        setRootStateClass(currentAdState);

        // From creative (may not exist yet)
        var videoUrl = '';
        var videoSide = '';
        var desktopExpanded = '';
        var desktopCollapsed = '';
        var mobileExpanded = '';
        var mobileCollapsed = '';

        function applyCreativePayloadIfAvailable() {
            if (!latestCreativePayload) return false;
            desktopExpanded = latestCreativePayload.desktopExpanded || '';
            desktopCollapsed = latestCreativePayload.desktopCollapsed || '';
            mobileExpanded = latestCreativePayload.mobileExpanded || '';
            mobileCollapsed = latestCreativePayload.mobileCollapsed || '';
            videoUrl = latestCreativePayload.videoUrl || '';
            videoSide = latestCreativePayload.videoSide || '';
            return true;
        }

        function updateBackgrounds() {
            if (!desktopExpanded || !mobileExpanded || !desktopCollapsed || !mobileCollapsed) return;

            if (currentAdState === 'expanded') {
                adBgDesktop.style.setProperty('background-image', 'url(' + desktopExpanded + ')', 'important');
                adBgMobile.style.setProperty('background-image', 'url(' + mobileExpanded + ')', 'important');
            } else {
                adBgDesktop.style.setProperty('background-image', 'url(' + desktopCollapsed + ')', 'important');
                adBgMobile.style.setProperty('background-image', 'url(' + mobileCollapsed + ')', 'important');
            }
        }


        function applyIframeAspectRatio() {
            var container = slotElement;
            if (!container) return;

            var iframe = container.querySelector('iframe');

            container.style.setProperty('width', '100%', 'important');
            container.style.setProperty('height', 'auto', 'important');
            container.style.setProperty('transition', 'aspect-ratio 0.3s ease', 'important');
            container.style.setProperty('will-change', 'aspect-ratio', 'important');

            if (iframe) {
                iframe.style.setProperty('width', '100%', 'important');
                iframe.style.setProperty('height', 'auto', 'important');
                iframe.style.setProperty('transition', 'aspect-ratio 0.3s ease', 'important');
                iframe.style.setProperty('will-change', 'aspect-ratio', 'important');
                iframe.style.setProperty('position', 'relative', 'important');
                iframe.style.setProperty('z-index', '1', 'important');
            }

            var isExpanded = currentAdState === 'expanded';
            var isMobile = window.innerWidth <= 767;
            var isWideScreen = window.innerWidth >= 1921;

            container.style.aspectRatio = '';
            if (iframe) iframe.style.aspectRatio = '';

            if (isWideScreen) {
                container.style.setProperty('width', '1600px', 'important');
                container.style.setProperty('margin', '0 auto', 'important');
                container.style.aspectRatio = 'auto';
                container.style.height = isExpanded ? '400px' : '160px';
                if (iframe) {
                    iframe.style.height = isExpanded ? '400px' : '160px';
                    iframe.style.setProperty('width', '1600px', 'important');
                    iframe.style.setProperty('margin', '0 auto', 'important');
                    iframe.style.aspectRatio = 'auto';
                }
            } else if (isMobile) {
                var mobileRatio = isExpanded ? '16 / 9' : '640 / 213';
                container.style.aspectRatio = mobileRatio;
                if (iframe) iframe.style.aspectRatio = mobileRatio;
            } else {
                var desktopRatio = isExpanded ? '4 / 1' : '10 / 1';
                container.style.aspectRatio = desktopRatio;
                if (iframe) iframe.style.aspectRatio = desktopRatio;
            }
        }

        function collapseAd() {

            trackAdEvent('ad_collapse', {
                reason: hasUserScrolled ? 'out_of_view' : 'programmatic'
            });
            adContainer.classList.remove('expanded');
            adContainer.classList.add('collapsed');
            videoPlayerContainer.classList.remove('ad-video-container-expanded');
            videoPlayerContainer.classList.add('ad-video-container-collapsed');
            setAdStateCookie('collapsed');
            currentAdState = 'collapsed';
            setRootStateClass(currentAdState); // <-- replace previous add()
            updateBackgrounds();
            applyIframeAspectRatio();

            if (videoSide) {
                videoPlayerContainer.classList.remove('ad-' + videoSide + '-expanded');
                videoPlayerContainer.classList.add('ad-' + videoSide + '-collapsed');
            }
        }

        function expandAd() {

            trackAdEvent('ad_expand');
            adContainer.classList.remove('collapsed');
            adContainer.classList.add('expanded');
            videoPlayerContainer.classList.remove('ad-video-container-collapsed');
            videoPlayerContainer.classList.add('ad-video-container-expanded');
            setAdStateCookie('expanded');
            currentAdState = 'expanded';
            setRootStateClass(currentAdState); // <-- replace previous add()
            updateBackgrounds();
            applyIframeAspectRatio();

            if (videoSide) {
                videoPlayerContainer.classList.remove('ad-' + videoSide + '-collapsed');
                videoPlayerContainer.classList.add('ad-' + videoSide + '-expanded');
            }
        }

        function setupIntersectionObserver() {
            var options = { root: null, rootMargin: '50px', threshold: [0] };
            var viewed = false;

            function handleIntersection(entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting && !viewed) {
                        viewed = true;
                        trackAdEvent('ad_visible');
                    }

                    // Only collapse if user has scrolled at least once
                    if (!entry.isIntersecting && hasUserScrolled && adContainer.classList.contains('expanded')) {
                        collapseAd();
                    }
                });
            }

            try {
                var observer = new IntersectionObserver(handleIntersection, options);
                observer.observe(adContainer);
            } catch (error) {
                console.error('[HPTO] IntersectionObserver error:', error);
            }
        }

        function wireVideoControlsIfAvailable() {
            if (!videoUrl || !videoSide) return;
            var vid = document.querySelector('#video-player video');
            if (!vid) return;

            vid.src = videoUrl;

            var autoplayTracked = false;

            vid.addEventListener('playing', function () {
                if (!autoplayTracked && vid.muted && vid.currentTime < 0.5) {
                    autoplayTracked = true;
                    trackAdEvent('ad_video_autoplay_start');
                }
            });

            videoPlayerContainer.classList.add('ad-' + videoSide + '-' + currentAdState);
            videoPlayerContainer.style.display = 'block';

            vid.addEventListener('loadeddata', function () {
                var playButton = videoPlayerContainer.querySelector('.play-button');
                var replayIcon = playButton.querySelector('.ended');
                var playingIcon = playButton.querySelector('.playing');
                var pausedIcon = playButton.querySelector('.paused');
                var muteButton = videoPlayerContainer.querySelector('.mute-button');
                var controlButtons = videoPlayerContainer.querySelector('.control-buttons');

                playButton.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (vid.paused || vid.ended) {
                        requestAnimationFrame(function () {
                            vid.play().then(function () {
                                playingIcon.style.display = 'block';
                                pausedIcon.style.display = 'none';
                                replayIcon.style.display = 'none';
                                controlButtons.classList.remove('ended');
                            }).catch(function (err) {
                                console.warn('[HPTO] Playback failed:', err);
                            });
                        });

                        trackAdEvent('ad_video_play', {
                            interaction: 'user'
                        });

                    } else {
                        vid.pause();
                        playingIcon.style.display = 'none';
                        pausedIcon.style.display = 'block';

                        trackAdEvent('ad_video_pause', {
                            time: Math.floor(vid.currentTime)
                        });
                    }
                });

                vid.addEventListener('ended', function () {
                    playingIcon.style.display = 'none';
                    pausedIcon.style.display = 'none';
                    replayIcon.style.display = 'block';
                    controlButtons.classList.add('ended');
                    collapseAd();

                    trackAdEvent('ad_video_complete', {
                        duration: Math.floor(vid.duration)
                    });
                });

                replayIcon.addEventListener('click', function (e) {
                    e.preventDefault();
                    vid.currentTime = 0;
                    replayIcon.style.display = 'none';
                    playingIcon.style.display = 'block';
                    controlButtons.classList.remove('ended');
                    requestAnimationFrame(function () {
                        vid.play().catch(function (err) {
                            console.warn('[HPTO] Replay failed:', err);
                        });
                    });
                    expandAd();

                    trackAdEvent('ad_video_replay');
                });

                muteButton.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Video starts muted by default
                    var wasMuted = vid.muted;

                    // Toggle mute state
                    vid.muted = !wasMuted;

                    // Update UI
                    muteButton.querySelector('.muted').style.display = vid.muted ? 'block' : 'none';
                    muteButton.querySelector('.with-sound').style.display = vid.muted ? 'none' : 'block';

                    // Track the actual user action
                    if (wasMuted) {
                        // User turned sound ON
                        trackAdEvent('ad_video_unmute');
                    } else {
                        // User turned sound OFF
                        trackAdEvent('ad_video_mute');
                    }
                });

                var quartiles = { 25: false, 50: false, 75: false };

                var quartileEvents = {
                    25: 'ad_video_quartile_25',
                    50: 'ad_video_quartile_50',
                    75: 'ad_video_quartile_75'
                };

                vid.addEventListener('timeupdate', function () {
                    if (!vid.duration) return;

                    var percent = (vid.currentTime / vid.duration) * 100;

                    [25, 50, 75].forEach(function (q) {
                        if (percent >= q && !quartiles[q]) {
                            quartiles[q] = true;
                            trackAdEvent(quartileEvents[q]);
                        }
                    });
                });
            });
        }

        // Apply payload now or poll briefly if not yet available
        if (!applyCreativePayloadIfAvailable()) {
            var tries = 0;
            var poll = setInterval(function () {
                if (applyCreativePayloadIfAvailable() || tries++ > 20) {
                    clearInterval(poll);
                    updateBackgrounds();
                    setupIntersectionObserver();
                    applyIframeAspectRatio();
                    wireVideoControlsIfAvailable();
                    if (currentAdState === 'expanded') expandAd(); else collapseAd();
                }
            }, 50);
        } else {
            updateBackgrounds();
            setupIntersectionObserver();
            applyIframeAspectRatio();
            wireVideoControlsIfAvailable();
            if (currentAdState === 'expanded') expandAd(); else collapseAd();
        }

        window.addEventListener('resize', applyIframeAspectRatio);
    }

    // ===== Boot =====
    attachMessageListenerOnce();
    attachGptListenerOnce();

    if (domReady()) {
        tryProcessHpto();
    } else {
        document.addEventListener('DOMContentLoaded', tryProcessHpto, { once: true });
    }

    // Watch for late DOM inserts
    var mo = new MutationObserver(tryProcessHpto);
    mo.observe(document.documentElement, { childList: true, subtree: true });
})();